export const stateOptionsObj = [
  // { value: '', label: 'none' },
  { value: 'AN', label: 'Andaman and Nicobar Islands' },
  { value: 'AP', label: 'Andhra Pradesh' },
  { value: 'AR', label: 'Arunachal Pradesh' },
  { value: 'AS', label: 'Assam' },
  { value: 'BR', label: 'Bihar' },
  { value: 'CG', label: 'Chandigarh' },
  { value: 'CH', label: 'Chhattisgarh' },
  { value: 'DH', label: 'Dadra and Nagar Haveli' },
  { value: 'DD', label: 'Daman and Diu' },
  { value: 'DL', label: 'Delhi' },
  { value: 'GA', label: 'Goa' },
  { value: 'GJ', label: 'Gujarat' },
  { value: 'HR', label: 'Haryana' },
  { value: 'HP', label: 'Himachal Pradesh' },
  { value: 'JK', label: 'Jammu and Kashmir' },
  { value: 'JH', label: 'Jharkhand' },
  { value: 'KA', label: 'Karnataka' },
  { value: 'KL', label: 'Kerala' },
  { value: 'LD', label: 'Lakshadweep' },
  { value: 'MP', label: 'Madhya Pradesh' },
  { value: 'MH', label: 'Maharashtra' },
  { value: 'MN', label: 'Manipur' },
  { value: 'ML', label: 'Meghalaya' },
  { value: 'MZ', label: 'Mizoram' },
  { value: 'NL', label: 'Nagaland' },
  { value: 'OR', label: 'Odisha' },
  { value: 'PY', label: 'Puducherry' },
  { value: 'PB', label: 'Punjab' },
  { value: 'RJ', label: 'Rajasthan' },
  { value: 'SK', label: 'Sikkim' },
  { value: 'TN', label: 'Tamil Nadu' },
  { value: 'TS', label: 'Telangana' },
  { value: 'TR', label: 'Tripura' },
  { value: 'UK', label: 'Uttarakhand' },
  { value: 'UP', label: 'Uttar Pradesh' },
  { value: 'WB', label: 'West Bengal' },
];
export const cityOptionObj = [
  { value: '', label: 'none' },
  { value: 'AGR', label: 'AGR' },
  { value: 'AGX', label: 'AGX' },
  { value: 'AIP', label: 'AIP' },
  { value: 'AJL', label: 'AJL' },
  { value: 'AKD', label: 'AKD' },
  { value: 'AMD', label: 'AMD' },
  { value: 'ATQ', label: 'ATQ' },
  { value: 'AUH', label: 'AUH' },
  { value: 'BBI', label: 'BBI' },
  { value: 'BDQ', label: 'BDQ' },
  { value: 'BEK', label: 'BEK' },
  { value: 'BEP', label: 'BEP' },
  { value: 'BHJ', label: 'BHJ' },
  { value: 'BHO', label: 'BHO' },
  { value: 'BHU', label: 'BHU' },
  { value: 'BKB', label: 'BKB' },
  { value: 'BLR', label: 'BLR' },
  { value: 'BOM', label: 'BOM' },
  { value: 'BPM', label: 'BPM' },
  { value: 'BUP', label: 'BUP' },
  { value: 'CBD', label: 'CBD' },
  { value: 'CCJ', label: 'CCJ' },
  { value: 'CCU', label: 'CCU' },
  { value: 'CDP', label: 'CDP' },
  { value: 'CJB', label: 'CJB' },
  { value: 'CNN', label: 'CNN' },
  { value: 'COH', label: 'COH' },
  { value: 'COK', label: 'COK' },
  { value: 'DAE', label: 'DAE' },
  { value: 'DAI', label: 'DAI' },
  { value: 'DBD', label: 'DBD' },
  { value: 'DED', label: 'DED' },
  { value: 'DEL', label: 'DEL' },
  { value: 'DEP', label: 'DEP' },
  { value: 'DHM', label: 'DHM' },
  { value: 'DIB', label: 'DIB' },
  { value: 'DIU', label: 'DIU' },
  { value: 'DMM', label: 'DMM' },
  { value: 'DMU', label: 'DMU' },
  { value: 'DOH', label: 'DOH' },
  { value: 'DXB', label: 'DXB' },
  { value: 'FJR', label: 'FJR' },
  { value: 'GAU', label: 'GAU' },
  { value: 'GAY', label: 'GAY' },
  { value: 'GOI', label: 'GOI' },
  { value: 'GOP', label: 'GOP' },
  { value: 'GUX', label: 'GUX' },
  { value: 'GWL', label: 'GWL' },
  { value: 'HBX', label: 'HBX' },
  { value: 'HJR', label: 'HJR' },
  { value: 'HO', label: 'HO' },
  { value: 'HSS', label: 'HSS' },
  { value: 'HYD', label: 'HYD' },
  { value: 'IDR', label: 'IDR' },
  { value: 'IMF', label: 'IMF' },
  { value: 'ISK', label: 'ISK' },
  { value: 'IXA', label: 'IXA' },
  { value: 'IXB', label: 'IXB' },
  { value: 'IXC', label: 'IXC' },
  { value: 'IXD', label: 'IXD' },
  { value: 'IXE', label: 'IXE' },
  { value: 'IXG', label: 'IXG' },
  { value: 'IXH', label: 'IXH' },
  { value: 'IXI', label: 'IXI' },
  { value: 'IXJ', label: 'IXJ' },
  { value: 'IXK', label: 'IXK' },
  { value: 'IXL', label: 'IXL' },
  { value: 'IXM', label: 'IXM' },
  { value: 'IXN', label: 'IXN' },
  { value: 'IXP', label: 'IXP' },
  { value: 'IXQ', label: 'IXQ' },
  { value: 'IXR', label: 'IXR' },
  { value: 'IXS', label: 'IXS' },
  { value: 'IXT', label: 'IXT' },
  { value: 'IXU', label: 'IXU' },
  { value: 'IXV', label: 'IXV' },
  { value: 'IXW', label: 'IXW' },
  { value: 'IXY', label: 'IXY' },
  { value: 'IXZ', label: 'IXZ' },
  { value: 'JAI', label: 'JAI' },
  { value: 'JDH', label: 'JDH' },
  { value: 'JGA', label: 'JGA' },
  { value: 'JGB', label: 'JGB' },
  { value: 'JLR', label: 'JLR' },
  { value: 'JRG', label: 'JRG' },
  { value: 'JRH', label: 'JRH' },
  { value: 'JSA', label: 'JSA' },
  { value: 'KLH', label: 'KLH' },
  { value: 'KNU', label: 'KNU' },
  { value: 'KQH', label: 'KQH' },
  { value: 'KTU', label: 'KTU' },
  { value: 'KUU', label: 'KUU' },
  { value: 'KWI', label: 'KWI' },
  { value: 'LDA', label: 'LDA' },
  { value: 'LKO', label: 'LKO' },
  { value: 'LTU', label: 'LTU' },
  { value: 'LUH', label: 'LUH' },
  { value: 'MAA', label: 'MAA' },
  { value: 'MCT', label: 'MCT' },
  { value: 'MYQ', label: 'MYQ' },
  { value: 'MZU', label: 'MZU' },
  { value: 'NAG', label: 'NAG' },
  { value: 'NDC', label: 'NDC' },
  { value: 'NMB', label: 'NMB' },
  { value: 'NVY', label: 'NVY' },
  { value: 'OMN', label: 'OMN' },
  { value: 'PAB', label: 'PAB' },
  { value: 'PAT', label: 'PAT' },
  { value: 'PBD', label: 'PBD' },
  { value: 'PGH', label: 'PGH' },
  { value: 'PNQ', label: 'PNQ' },
  { value: 'PNY', label: 'PNY' },
  { value: 'PUT', label: 'PUT' },
  { value: 'PYB', label: 'PYB' },
  { value: 'PYG', label: 'PYG' },
  { value: 'QJU', label: 'QJU' },
  { value: 'QNB', label: 'QNB' },
  { value: 'QNF', label: 'QNF' },
  { value: 'QNW', label: 'QNW' },
  { value: 'RAJ', label: 'RAJ' },
  { value: 'RDP', label: 'RDP' },
  { value: 'REW', label: 'REW' },
  { value: 'RGH', label: 'RGH' },
  { value: 'RJA', label: 'RJA' },
  { value: 'RJI', label: 'RJI' },
  { value: 'RMD', label: 'RMD' },
  { value: 'RPR', label: 'RPR' },
  { value: 'RRK', label: 'RRK' },
  { value: 'RTC', label: 'RTC' },
  { value: 'RUP', label: 'RUP' },
  { value: 'SAG', label: 'SAG' },
  { value: 'SHL', label: 'SHL' },
  { value: 'SLV', label: 'SLV' },
  { value: 'SSE', label: 'SSE' },
  { value: 'STV', label: 'STV' },
  { value: 'SXR', label: 'SXR' },
  { value: 'SXV', label: 'SXV' },
  { value: 'TCR', label: 'TCR' },
  { value: 'TEI', label: 'TEI' },
  { value: 'TEZ', label: 'TEZ' },
  { value: 'TIR', label: 'TIR' },
  { value: 'TJV', label: 'TJV' },
  { value: 'TNI', label: 'TNI' },
  { value: 'TRV', label: 'TRV' },
  { value: 'TRZ', label: 'TRZ' },
  { value: 'UDR', label: 'UDR' },
  { value: 'VDY', label: 'VDY' },
  { value: 'VGA', label: 'VGA' },
  { value: 'VLF', label: 'VLF' },
  { value: 'VNS', label: 'VNS' },
  { value: 'VTZ', label: 'VTZ' },
  { value: 'WGC', label: 'WGC' },
  { value: 'XXB', label: 'XXB' },
  { value: 'ZER', label: 'ZER' },
];
